export const dataURItoBlob = (dataURI: string): Blob => {
  if (!dataURI || typeof dataURI !== "string") {
    throw new Error("Invalid data URI: input must be a non-empty string");
  }

  const parts = dataURI.split(",");
  if (parts.length !== 2) {
    throw new Error("Invalid data URI format: missing comma separator");
  }

  const [header, data] = parts;
  if (!data) {
    throw new Error("Invalid data URI: missing data portion");
  }

  const mimeMatch = header?.match(/^data:([^;]+)/);
  const mimeString = mimeMatch?.[1] ?? "application/octet-stream";

  let byteString: string;
  try {
    byteString = atob(data);
  } catch {
    throw new Error("Invalid data URI: base64 decoding failed");
  }

  const arrayBuffer = new ArrayBuffer(byteString.length);
  const byteArray = new Uint8Array(arrayBuffer);
  for (let i = 0; i < byteString.length; i++) {
    byteArray[i] = byteString.charCodeAt(i);
  }

  return new Blob([arrayBuffer], { type: mimeString });
};

export const getContentTypeFromExtension = (extension: string): string => {
  if (extension.toLowerCase() === "docx") {
    return "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
  }
  return "application/octet-stream";
};
